/**
 * Sidebar 아이콘
 * SVG 원본: src/assets/icons/sidebar/*.svg (같은 파일명으로 교체하면 반영됨)
 * - SVG 색상은 currentColor 사용 (CSS color 로 상태별 색 변경)
 * - menuCd(DDB) 키 → SVG 매핑
 */

import type { FC, SVGProps } from 'react';
import HomeIcon from '../../assets/icons/sidebar/home.svg?react';
import TemplatesIcon from '../../assets/icons/sidebar/templates.svg?react';
import KnowledgeIcon from '../../assets/icons/sidebar/knowledge.svg?react';
import WorkflowIcon from '../../assets/icons/sidebar/workflow.svg?react';
import ChatIcon from '../../assets/icons/sidebar/chat.svg?react';
import MarketplaceIcon from '../../assets/icons/sidebar/marketplace.svg?react';
import DashboardIcon from '../../assets/icons/sidebar/dashboard.svg?react';
import AdminIcon from '../../assets/icons/sidebar/admin.svg?react';
import SystemIcon from '../../assets/icons/sidebar/system.svg?react';
import UsersIcon from '../../assets/icons/sidebar/users.svg?react';
import UserPortalIcon from '../../assets/icons/sidebar/user-portal.svg?react';
import MenuIcon from '../../assets/icons/sidebar/menu.svg?react';
import ChevronDownIcon from '../../assets/icons/sidebar/chevron-down.svg?react';
import ChevronUpIcon from '../../assets/icons/sidebar/chevron-up.svg?react';
import GlobeIcon from '../../assets/icons/sidebar/globe.svg?react';
import DarkModeIcon from '../../assets/icons/sidebar/darkmode.svg?react';
import LogoutIcon from '../../assets/icons/sidebar/logout.svg?react';
import FallbackIcon from '../../assets/icons/sidebar/fallback.svg?react';
import LogsIcon from '../../assets/icons/sidebar/logs.svg?react';
import AppsIcon from '../../assets/icons/sidebar/apps.svg?react';
import SpacesIcon from '../../assets/icons/sidebar/spaces.svg?react';

export const SidebarIcons: Record<string, FC<SVGProps<SVGSVGElement>>> = {
  // 메뉴 (menuCd)
  home: HomeIcon,
  templates: TemplatesIcon,
  knowledge: KnowledgeIcon,
  workflow: WorkflowIcon,
  chat: ChatIcon,
  apps: AppsIcon,
  spaces: SpacesIcon,
  marketplace: MarketplaceIcon,
  dashboard: DashboardIcon,
  admin: AdminIcon,
  system: SystemIcon,
  users: UsersIcon,
  userPortal: UserPortalIcon,
  // UI
  menu: MenuIcon,
  chevronDown: ChevronDownIcon,
  chevronUp: ChevronUpIcon,
  globe: GlobeIcon,
  darkmode: DarkModeIcon,
  logout: LogoutIcon,
  // 매핑 없는 menuCd 용
  fallback: FallbackIcon,
  logs: LogsIcon,
};

export function SidebarIcon({ name }: { name: string }) {
  const Icon = SidebarIcons[name] ?? SidebarIcons.fallback;
  // 크기는 1em (svgr icon 옵션) → 부모 font-size 를 따라감
  return <Icon aria-hidden="true" />;
}
